export default __webpack_public_path__ + "static/media/backdate-calendars.9383d7de.svg";